import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_NOTES_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetApplicationNotes extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = APPLICATION_NOTES_LIST_URL;

  constructor(applicationId) {
    super();
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
